import styled from 'styled-components';

import { Skeleton } from 'ui/skeleton';
import { pxToRem } from 'utils/convert';

import { Cell } from 'modules/userProfiles/components/table';
import { ORDERED_TABLE_COLUMNS } from '../constants';

const SkeletonCell = styled(Cell)`
  height: ${pxToRem(90)};
`;

export const ListSkeletonRow = () => (
  <>
    {ORDERED_TABLE_COLUMNS.map((id) => (
      <SkeletonCell columnId={id} key={id}>
        <Skeleton />
      </SkeletonCell>
    ))}
  </>
);
